// Coordenadas aproximadas (centroides) de los cantones más importantes de Costa Rica
// Lat, Lng
export const CANTON_COORDS = {
  // San José
  "San José": [9.9325, -84.0795],
  "Escazú": [9.9189, -84.1395],
  "Desamparados": [9.8957, -84.0668],
  "Puriscal": [9.8453, -84.3148],
  "Tarrazú": [9.6543, -84.0085],
  "Aserrí": [9.8590, -84.0904],
  "Mora": [9.9192, -84.2473],
  "Goicoechea": [9.9519, -84.0335],
  "Santa Ana": [9.9326, -84.1839],
  "Alajuelita": [9.9054, -84.0935],
  "Vázquez de Coronado": [9.9866, -84.0044],
  "Acosta": [9.7913, -84.1639],
  "Tibás": [9.9612, -84.0838],
  "Moravia": [9.9755, -84.0511],
  "Montes de Oca": [9.9387, -84.0179],
  "Turrubares": [9.7849, -84.4029],
  "Dota": [9.6502, -83.9275],
  "Curridabat": [9.9143, -84.0307],
  "Pérez Zeledón": [9.3667, -83.7000],
  "León Cortés": [9.7269, -84.0207],
  
  // Alajuela
  "Alajuela": [10.0163, -84.2117],
  "San Ramón": [10.0876, -84.4699],
  "Grecia": [10.0717, -84.3144],
  "San Mateo": [9.9526, -84.5290],
  "Atenas": [9.9786, -84.3793],
  "Naranjo": [10.0975, -84.3819],
  "Palmares": [10.0560, -84.4356],
  "Poás": [10.0717, -84.2475],
  "Orotina": [9.9082, -84.5202],
  "San Carlos": [10.4634, -84.4280],
  "Zarcero": [10.1925, -84.3925],
  "Sarchí": [10.0865, -84.3618],
  "Upala": [10.9000, -85.0167],
  "Los Chiles": [11.0353, -84.7164],
  "Guatuso": [10.6850, -84.8369],
  "Río Cuarto": [10.3500, -84.2167],

  // Cartago
  "Cartago": [9.8638, -83.9192],
  "Paraíso": [9.8358, -83.8634],
  "La Unión": [9.9080, -83.9819],
  "Jiménez": [9.7568, -83.7466],
  "Turrialba": [9.9018, -83.6764],
  "Alvarado": [9.8941, -83.7679],
  "Oreamuno": [9.9001, -83.9101],
  "El Guarco": [9.8284, -83.9683],

  // Heredia
  "Heredia": [9.9985, -84.1198],
  "Barva": [10.0271, -84.1224],
  "Santo Domingo": [9.9774, -84.0859],
  "Santa Bárbara": [10.0273, -84.1601],
  "San Rafael": [10.0214, -84.1042],
  "San Isidro": [10.0314, -84.0524],
  "Belén": [9.9772, -84.1843],
  "Flores": [9.9961, -84.1639],
  "San Pablo": [10.0028, -84.1010],
  "Sarapiquí": [10.4636, -84.0184],

  // Guanacaste
  "Liberia": [10.6346, -85.4377],
  "Nicoya": [10.1485, -85.4527],
  "Santa Cruz": [10.2620, -85.5859],
  "Bagaces": [10.5240, -85.2535],
  "Carrillo": [10.4214, -85.4979],
  "Cañas": [10.4283, -85.0928],
  "Abangares": [10.2867, -85.0431],
  "Tilarán": [10.4708, -84.9669],
  "Nandayure": [9.9333, -85.3000],
  "La Cruz": [11.0750, -85.6286],
  "Hojancha": [10.0418, -85.4153],

  // Puntarenas
  "Puntarenas": [9.9763, -84.8384],
  "Esparza": [9.9963, -84.6628],
  "Buenos Aires": [9.1742, -83.3372],
  "Montes de Oro": [10.0942, -84.7128],
  "Osa": [8.9522, -83.4775],
  "Aguirre": [9.4500, -84.1333],
  "Quepos": [9.4319, -84.1620],
  "Golfito": [8.6361, -83.1599],
  "Coto Brus": [8.7872, -82.9636],
  "Parrita": [9.5184, -84.3215],
  "Corredores": [8.6293, -82.9342],
  "Garabito": [9.6149, -84.6293],
  "Monteverde": [10.3000, -84.8167],
  "Puerto Jiménez": [8.5333, -83.3000],

  // Limón
  "Limón": [9.9905, -83.0359],
  "Pococí": [10.2333, -83.5333],
  "Siquirres": [10.0975, -83.5036],
  "Talamanca": [9.5667, -82.8833],
  "Matina": [10.0925, -83.2848],
  "Guácimo": [10.2128, -83.6925],
};

// Centro de Costa Rica para el mapa
export const COSTA_RICA_CENTER = [9.7489, -84.0833];
export const COSTA_RICA_ZOOM = 7;
